import React from "react";
import PageShell from "@/components/PageShell";
import PageHeader from "@/components/PageHeader";
import About from "@/components/sections/About";
import CTASection from "@/components/CTASection";

export default function AboutPage() {
    return (
        <PageShell>
            <div data-testid="about-page">
                <PageHeader
                    eyebrow="About NexaReach"
                    title="The team behind every"
                    accent="meaningful introduction."
                    subtitle="We're a small, deliberate firm of outreach specialists, traders, and client-success operators — partnered exclusively with Vantage Markets."
                    breadcrumbs={[{ label: "About" }]}
                />
                <About />
                <CTASection
                    eyebrow="Talk to the Team"
                    title="Have a question about"
                    accent="our approach?"
                    subtitle="We're transparent about what we do, how we do it, and why we believe Vantage is worth introducing to traders we respect."
                />
            </div>
        </PageShell>
    );
}
